import { render, staticRenderFns } from "./VerifyEmailComp.vue?vue&type=template&id=7118d635&scoped=true&"
import script from "./VerifyEmailComp.vue?vue&type=script&lang=ts&"
export * from "./VerifyEmailComp.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyEmailComp.vue?vue&type=style&index=0&id=7118d635&lang=scss&scoped=true&"
import style1 from "./VerifyEmailComp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7118d635",
  null
  
)

export default component.exports